var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalculator = function SvgCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 9.4a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM6.9 9.4a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM9.6 9.4a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 1H2c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V2c0-.6-.5-1-1-1Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.8h12",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 11.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM6.9 11.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM9.6 11.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM4.3 14.4a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM6.9 14.4a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM9.6 14.4a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z",
    fill: "currentColor"
  })));
};
export default SvgCalculator;